import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { CustomerType, CustomFieldItem, OrderCustomFields, OrderCustomFieldDifinitions } from "@app/types/orders";
import { fetchTrackOrder } from "./sharedThunks";

export interface CustomerState {
  customerId: string;
  name: string,
  type: CustomerType,
  avatarPhoto?: string
  accessToken: string,
  customFields: CustomFieldItem[] | null
  /** Raw values/definitions kept alongside the already-resolved
   * `customFields` above (used by legacy UI) — see
   * `Address.rawCustomFields` (types/orders.ts) for why new (v2) consumers
   * read these instead. */
  rawCustomFields: OrderCustomFields | null;
  rawCustomFieldDefinitions: OrderCustomFieldDifinitions[] | null;
}

const initialState: CustomerState = {
  customerId: '',
  name: '',
  type: 'individual',
  accessToken: '',
  customFields: null,
  rawCustomFields: null,
  rawCustomFieldDefinitions: null,
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomer: (state, action: PayloadAction<CustomerState>) => {
      state.customerId = action.payload.customerId;
      state.name = action.payload.name;
      state.type = action.payload.type;
      state.avatarPhoto = action.payload.avatarPhoto;
      state.accessToken = action.payload.accessToken;
    },
  },
  extraReducers: (builder) => {
      builder
        .addCase(fetchTrackOrder.fulfilled, (state, action) => {
          let order = action.payload.order;
          let customer = action.payload.order.customer;
          
          state.customerId = order.customerId;
          state.name = customer.name;
          state.type = customer.type;
          state.avatarPhoto = customer.avatarPhoto;
          state.accessToken = action.payload.accessToken;
          state.rawCustomFields = customer.customFields;
          state.rawCustomFieldDefinitions = customer.customFieldDefinitions;


          if(customer && customer.customFieldDefinitions && customer.customFieldDefinitions.length > 0 && customer.customFields){
            const customerCustomFields = customer.customFields; 
            const customFields : CustomerState['customFields'] = [];
  
            customer.customFieldDefinitions.forEach(cfd => {
                console.log(customFields);
                
                if(customerCustomFields[cfd.key] !== undefined && customerCustomFields[cfd.key] !== "" && customerCustomFields[cfd.key] !== null){
                  let value = customerCustomFields[cfd.key];
                  let label = cfd.label;
                  if(cfd.config.type === 'select'){
                      value = cfd.config.choices.find(c => c.key === customerCustomFields[cfd.key])?.label ?? '-';
                  }else if (cfd.config.type === 'file'){
                    let data: any = customerCustomFields[cfd.key];
                    label = data.name;
                    value = data.url;
                  }else if (cfd.config.type === 'boolean' && customerCustomFields[cfd.key] === true){
                    let data: any = customerCustomFields[cfd.key];
                    value = data;
                  }
                  
                  customFields.push({
                    key: cfd.key,
                    label: label,
                    value: value,
                    type: cfd.config.type
                  })
  
                }
            });
            
            state.customFields = customFields;
  
          }
    

        })
    },



});

// Action creators are generated for each case reducer function
export const { setCustomer } = customerSlice.actions;

export default customerSlice.reducer;
